"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _apiClient = _interopRequireDefault(require("hub-http/clients/apiClient"));

var BASE_URI = 'composition/v1/users';

var UsersManager = /*#__PURE__*/function () {
  function UsersManager() {
    (0, _classCallCheck2.default)(this, UsersManager);
  }

  (0, _createClass2.default)(UsersManager, [{
    key: "fetch",
    value: function fetch() {
      return _apiClient.default.get(BASE_URI);
    }
  }]);
  return UsersManager;
}();

exports.default = UsersManager;
module.exports = exports.default;